import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import { getImage } from "gatsby-plugin-image";
import { convertToBgImage } from "gbimage-bridge";
import { PageHeaderWrap } from "./style";
import { StyledTitle } from "../../../templates/single-blog/style";

const PageHeader = ({ title }) => {
    const disableLinks = [
        "/elements",
        "/category",
        "/profile",
        "/date",
        "/tag",
        "/page",
        "/blog",
        "/blog/page",
        "/blogs",
        "/services",
    ];
    const imageData = useStaticQuery(graphql`
        query breadCrumbImgQuery {
            file(relativePath: { eq: "bg/title-bar-01-bg.jpg" }) {
                childImageSharp {
                    gatsbyImageData(
                        layout: FULL_WIDTH
                        placeholder: TRACED_SVG
                        formats: WEBP
                        quality: 100
                    )
                }
            }
        }
    `);
    const bgImage = convertToBgImage(getImage(imageData.file));
    return (
        <PageHeaderWrap {...bgImage}>
            <StyledTitle>{title}</StyledTitle>
        </PageHeaderWrap>
    );
};

PageHeader.propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string,
    }),
    title: PropTypes.string,
};

export default PageHeader;
